<template>
  <PdpTabExpandableContent :headline="infoText.type">
    <!-- eslint-disable vue/no-v-html -->
    <div class="content" v-html="infoText.value" />
  </PdpTabExpandableContent>
</template>

<script>
import PdpTabExpandableContent from 'Components/02-molecules/pdp-tab-expandable-content/PdpTabExpandableContent.vue';
import { InfoTextsEnum } from 'Src/components/03-organisms/product-details-26/models/info-texts.enum';

const TabNameEnum = {
  generalInfo: 'GENERAL_INFO',
  techInfo: 'TECH_INFO',
};

export default {
  name: 'PdpTabInfoTexts',
  components: { PdpTabExpandableContent },
  props: {
    tabName: {
      type: String,
      default: '',
      required: true,
    },
    infoTexts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    infoText() {
      const tabName = TabNameEnum[this.tabName];
      if (!tabName) return { type: '', value: '' };

      return (
        this.infoTexts.find((info) => info.type === InfoTextsEnum[tabName]) || {
          type: '',
          value: '',
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';

.content {
  white-space: pre-line;
  font-size: var(--font-size-M);
  line-height: var(--font-size-MLL);

  a {
    color: var(--color-secondary);
    text-decoration: underline;
  }

  p + p {
    margin-top: 1em;
  }
}
</style>
